import { render, staticRenderFns } from "./TelegramMessagePreview.vue?vue&type=template&id=19bb6702&scoped=true&"
import script from "./TelegramMessagePreview.vue?vue&type=script&lang=js&"
export * from "./TelegramMessagePreview.vue?vue&type=script&lang=js&"
import style0 from "./TelegramMessagePreview.vue?vue&type=style&index=0&id=19bb6702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bb6702",
  null
  
)

export default component.exports